export const Hamming = {
  encode(bits: number[]): number[] {
    const padded = [...bits];
    while (padded.length % 4 !== 0) padded.push(0);
    const coded: number[] = [];
    for (let i = 0; i < padded.length; i += 4) {
      const [d1, d2, d3, d4] = padded.slice(i, i + 4);
      coded.push(d1 ^ d2 ^ d4, d1 ^ d3 ^ d4, d1, d2 ^ d3 ^ d4, d2, d3, d4);
    }
    return coded;
  },

  decode(bits: number[]): { data: number[]; corrected: number } {
    const data: number[] = [];
    let corrected = 0;
    for (let i = 0; i + 7 <= bits.length; i += 7) {
      const b = bits.slice(i, i + 7);
      const s1 = b[0] ^ b[2] ^ b[4] ^ b[6];
      const s2 = b[1] ^ b[2] ^ b[5] ^ b[6];
      const s3 = b[3] ^ b[4] ^ b[5] ^ b[6];
      const syndrome = s1 + s2 * 2 + s3 * 4;
      if (syndrome) {
        b[syndrome - 1] ^= 1;
        corrected++;
      }
      data.push(b[2], b[4], b[5], b[6]);
    }
    return { data, corrected };
  },

  codedLength(dataBits: number): number {
    return Math.ceil(dataBits / 4) * 7;
  },
};
